module.exports = new __parcel__URL__("violin_select.6e5e1104.mp3").toString();